<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-8-tablet is-12-desktop">
        <div class="status-container">
          <template v-if="paymentSucceeded">
            <div class="status success"><i class="fas fa-check"></i></div>
            <div>{{ $t("checkout.payment_success") }}</div>
          </template>
          <template v-else>
            <div class="status error"><i class="fas fa-times"></i></div>
            <div>{{ $t("checkout.payment_failed") }}</div>
            <div v-if="errorMessage">
              <p>{{ errorMessage }}</p>
            </div>
          </template>
          <div class="redirect">{{ $t("labels.redirecting") }}</div>
          <div class="mt-3"><img src="@/assets/img/loading.svg" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import "@/components/Payment/PaymentCompleted.scss";
</style>
<script>
"use strict";
import { mapState } from "vuex";
import { get_redirect_urls } from "@/helper/redirectUrls";
import { check_hybridapi_method_exist } from "../../hybridapi";

export default {
  name: "PaymentCompleted",
  data() {
    return {
      success: false,
      timer: null,
      errorMessage: null,
    };
  },
  computed: {
    ...mapState({
      paymentSucceeded: (state) => state.payment.stripePaymentSucceeded,
      selectedProduct: (state) => state.payment.selectedProduct,
    }),
  },
  mounted() {
    const redirect_status = this.$route.query.redirect_status;
    this.errorMessage = this.$route.query.error_message;

    if (redirect_status == "succeeded") {
      this.$store.dispatch("payment/setStripePaymentSucceeded", true);
    }

    // If close button tapped on hybrid popup
    window["backButtonTapped"] = () => {
      // do nothing bec. it's closing after 3 min automatically
      return "nothing";
    };

    // this.$store.dispatch("client/setHybridPage", true);

    if (check_hybridapi_method_exist("close")) {
      // for ios client
      this.$hybridapi("updatePageTitle", this.$t("labels.do_payment"));
      this.$hybridapi("updateWindowSize", "medium");
      // this.$hybridapi("hideLoading");
      this.timer = setTimeout(() => {
        // This timeout added for web
        setTimeout(() => {
          this.$hybridapi("close", "close");
          this.$store.dispatch("payment/setStripePaymentSucceeded", false);
          this.$store.dispatch("payment/setSelectedProduct", null);
          this.$store.dispatch("payment/setSelectedPaymentMethod", null);
        }, 500);
      }, 5000);
    } else {
      this.redirectIfRequired(this.paymentSucceeded);
    }
  },
  methods: {
    redirectIfRequired(status) {
      let [success_redirect_url, failed_redirect_url] = get_redirect_urls();

      // Eğer URL'de yoksa, sessionStorage'dan geri yükle (Safari için)
      if (!success_redirect_url && !failed_redirect_url) {
        try {
          const savedParams = sessionStorage.getItem("stripe_redirect_params");
          if (savedParams) {
            const parsedParams = JSON.parse(savedParams);
            success_redirect_url = parsedParams.success_redirect_url;
            failed_redirect_url = parsedParams.failed_redirect_url;
          }
        } catch (error) {
          console.error("sessionStorage error:", error);
        }
      }

      if (!(success_redirect_url || failed_redirect_url)) {
        return;
      }

      const redirect_url = status ? success_redirect_url : failed_redirect_url;

      try {
        const url_to_go = new URL(redirect_url);

        // sessionStorage'ı temizle
        sessionStorage.removeItem("stripe_redirect_params");

        window.location.replace(url_to_go);
      } catch (error) {
        console.error("invalid redirect url", error);
      }
    },
  },
  unmounted() {
    this.timer = null;
  },
};
</script>
